import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {tap} from 'rxjs/operators';
import { ApplicationSettings } from '../../shared/model/application.settings';
import {lastValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SettingsLoaderService {
  private readonly CONFIG_URL = 'assets/env/application-config.json';
  public configuration: ApplicationSettings;

  constructor(private http: HttpClient) {
  }

  public loadConfigurations(): Promise<ApplicationSettings> {
    return this.loadConfigurationFile(this.CONFIG_URL);
  }

  private async loadConfigurationFile(filePath: string): Promise<ApplicationSettings> {
    if (!this.configuration?.supouiEndpoint || this.configuration?.supouiEndpoint === '') {
      const settingsObservable = this.http.get<ApplicationSettings>(filePath).pipe(tap(settings => {
        this.configuration = settings;
      }));
      return lastValueFrom(settingsObservable);
    }
    return Promise.resolve(this.configuration);
  }
}
